// import component from '@layui/layui-vue/types/component/backTop'
import { createRouter, createWebHashHistory } from 'vue-router'
// import { setFooterRoutes } from '@/utils/footerRoutes'
// import { useStore } from 'vuex'

// const store = useStore()
// const footerList = sessionStorage.getItem('footerList') || []
// const footerRoutes = setFooterRoutes(JSON.parse(footerList))
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/subsystem',
    name: 'subsystem',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/SubsystemEntryView.vue'),
    children: [{
      path: '/subsystem/home',
      name: '/subsystem/home',
      component: () => import('@/views/common/MainView.vue')
    }, {
      path: '/cw/home',
      name: '/cw/home',
      component: () => import('@/views/business/cw/CwHome.vue')
    }, {
      path: '/cw/report',
      name: '/cw/report',
      component: () => import('@/views/business/cw/PerformentReport.vue')
    }, {
      path: '/cz/home',
      name: '/cz/home',
      component: () => import('@/views/business/cz/CzHome.vue')
    }, {
      path: '/cw/budget',
      name: '/cw/budget',
      component: () => import('@/views/business/cw/Budgeting.vue')
    }, {
      path: '/cw/value',
      name: '/cw/value',
      component: () => import('@/views/business/cw/Valuedecisions.vue')
    }, {
      path: '/cw/fund',
      name: '/cw/fund',
      component: () => import('@/views/business/cw/Working.vue')
    }, {
      path: '/cw/allocation',
      name: '/cw/allocation',
      component: () => import('@/views/business/cw/Allocation.vue')
    }, {
      path: '/cw/operate',
      name: '/cw/operate',
      component: () => import('@/views/business/cw/Business.vue')
    }, {
      path: '/cw/data',
      name: '/cw/data',
      component: () => import('@/views/business/cw/Acquisition.vue')
    }, {
      path: '/cz/budget',
      name: '/cz/budget',
      component: () => import('@/views/business/cz/BudgetMaking.vue')
    }, {
      path: '/cz/account',
      name: '/cz/account',
      component: () => import('@/views/business/cz/AccountMaking.vue')
    }, {
      path: '/cz/evaluation',
      name: '/cz/evaluation',
      component: () => import('@/views/business/cz/PerformanceEvaluation.vue')
    }, {
      path: '/cz/information',
      name: '/cz/information',
      component: () => import('@/views/business/cz/BasedInformation.vue')
    }, {
      path: '/cz/regulation',
      name: '/cz/regulation',
      component: () => import('@/views/business/cz/ReferRegulation.vue')
    }, {
      path: '/dsj/home',
      name: '/dsj/home',
      component: () => import('@/views/business/dsj/DsjHome.vue')
    }, {
      path: '/fgk/home',
      name: '/fgk/home',
      component: () => import('@/views/business/fgk/FgkHome.vue')
    }, {
      path: '/fl/home',
      name: '/fl/home',
      component: () => import('@/views/business/fl/FlHome.vue')
    }, {
      path: '/kc/home',
      name: '/kc/home',
      component: () => import('@/views/business/kc/KcHome.vue')
    }, {
      path: '/kj/home',
      name: '/kj/home',
      component: () => import('@/views/business/kj/KjHome.vue')
    }, {
      path: '/pg/home',
      name: '/pg/home',
      component: () => import('@/views/business/pg/PgHome.vue')
    }, {
      path: '/rc/home',
      name: '/rc/home',
      component: () => import('@/views/business/rc/RcHome.vue')
    }, {
      path: '/rz/home',
      name: '/rz/home',
      component: () => import('@/views/business/rz/RzHome.vue')
    }, {
      path: '/sj/home',
      name: '/sj/home',
      component: () => import('@/views/business/sj/SjHome.vue')
    }, {
      path: '/ss/home',
      name: '/ss/home',
      component: () => import('@/views/business/ss/SsHome.vue')
    }, {
      path: '/sw/home',
      name: '/sw/home',
      component: () => import('@/views/business/sw/SwHome.vue')
    }, {
      path: '/tz/home',
      name: '/tz/home',
      component: () => import('@/views/business/tz/TzHome.vue')
    }, {
      path: '/yq/home',
      name: '/yq/home',
      component: () => import('@/views/business/yq/YqHome.vue')
    }]
  },
  {
    path: '/footer',
    name: '/footer',
    component: () => import('@/views/PublicUsView.vue')
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('@/views/AboutUsView.vue')
  },
  {
    path: '/service',
    name: '/service',
    component: () => import('@/views/ServiceUsView.vue')
  },
  {
    path: '/serviceteam',
    name: '/serviceteam',
    component: () => import('@/views/ServiceTeamUsView.vue')
  },
  {
    path: '/dynamic',
    name: '/dynamic',
    component: () => import('@/views/DynamicUsView.vue')
  },
  {
    path: '/statement',
    name: '/statement',
    component: () => import('@/views/StatementUsView.vue')
  },
  // 侧边栏：服务咨询
  {
    path: '/serveconsult',
    name: '/serveconsult',
    component: () => import('@/views/ServiceConsultation.vue')
  },
  // 侧边栏：应用咨询
  {
    path: '/appconsult',
    name: '/appconsult',
    component: () => import('@/views/ApplicationConsultation.vue')
  },
  // 侧边栏：联系客服
  {
    path: '/cusconsult',
    name: '/cusconsult',
    component: () => import('@/views/CustomerService.vue')
  }
]

console.log(routes)

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 重置路由
export function resetRouter () {
  router.matcher = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: []
  }).matcher
}

export default router
